import { api } from "../Apis/interceptor";

export const findSaved = function (
  curCustomer,
  bid_team_role,
  opportunity_id,
  winstage
) {
  return api.get(
    "/api/v1/bidteamsaved/" +
      curCustomer +
      "/" +
      bid_team_role +
      "/" +
      opportunity_id +
      "/" +
      winstage
  );
};

export const saveBidteam = function (user_role, bidData) {
  return api.put("/api/v1/saveBidteam/" + user_role, bidData);
};
